/* eslint-disable indent */
/* global initCookieConsent */

import Sharer from 'sharer.js';
import { setupAjaxUtils, useAjaxAutoBrowserHistoryUpdate } from './ajax-utils';
import { detectBsBreakpoint } from './detect-bs-breakpoint';
import './carousels.init.js';
//import 'vanilla-cookieconsent';
//import "vanilla-cookieconsent/dist/cookieconsent.css";
import '../scss/application.scss';



$(function () {
	// initialize ajax-utils
	setupAjaxUtils();
});

//$(function () {
//	$(".iubenda-tp-btn.iubenda-cs-preferences-link")
//		.addClass("btn btn-danger btn-full-rounded")
//		.removeAttr("data-tp-anchored")
//		.attr("data-tp-nostyle", true)
//		.attr("id", "cookie-tab")
//		//.css({ bottom: "1rem !important", top: "auto !important" })
//})

$(function () {

	function populateGrid(posts) { 
		posts.forEach((p) => {
			let caption = p.caption;
			let maxLength = 100 // maximum number of characters to extract
			let trimmedString = caption.substr(0, maxLength);
			trimmedString = trimmedString.substr(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(" ")))
			let card = `
				<div>
					<a href="${p.permalink}" target="_blank" title="Apri su Instagram"><img src="${p.sizes.medium.mediaUrl}" /></a>
				</div>
			`;
			$("#instagram-feed").append(card)
		})
	}

	if (!$("#instagram-feed").length) return;

	const url = $("#instagram-feed").data("url");
	fetch(url).then((response) => {
		if (response.ok) {
			return response.json();
		}
		throw new Error('Something went wrong');
	})
		.then((responseJson) => {
			console.log(responseJson)
			populateGrid(responseJson.posts)
		})
		.catch((error) => {
			console.log(error)
		});

})

$(function () {
	if (!$("body").hasClass("homepage")) return;

	var header = $("header");

	$(window).on("scroll", function () {
		var scrollTop = $(window).scrollTop();
		var isScrolled = scrollTop > ($("#main-carousel").height() - 150);
		if (isScrolled) {
			header.addClass("header-solid");
		} else {
			header.removeClass("header-solid");
		}
	});

	var scrollTop = $(window).scrollTop();
	var isScrolled = scrollTop > ($("#main-carousel").height() - 150);
	if (isScrolled) {
		header.addClass("header-solid");
	}
});

$(function () {

	if ($("body").hasClass("homepage")) return;

	var header = $("header");

	$(window).on("scroll", function () {
		let scrollTop = $(window).scrollTop();
		let isScrolled = false;
		if ($(".page-hero").length) {
			isScrolled = scrollTop > $(".page-content").offset().top - ($(".page-hero").innerHeight() - 120);
		}

		if ($(".page-title").length) {
			const headerHeight = $("header").innerHeight()
			console.log((scrollTop + $("header").height()) > $(".page-title"), $(".page-content").offset().top)
			isScrolled = scrollTop > 25;
		}

		if (isScrolled) {
			header.addClass("header-solid");
		} else {
			header.removeClass("header-solid");
		}
	});

	let scrollTop = $(window).scrollTop();
	let isScrolled = false;
	if ($(".page-hero").length) {
		isScrolled = scrollTop > $(".page-content").offset().top - ($(".page-hero").innerHeight() - 120);
	}

	if ($(".page-title").length) {
		isScrolled = false // scrollTop > $(".page-title").offset().top - ($(".page-title").innerHeight() - 100);
	}

	if (isScrolled) {
		header.addClass("header-solid");
	}
});


/* Back to top and Cookie buttons */
$(function () {
	//if (!$("#iubenda-cs-banner").is(":visible")) {
	//	$("#cookie-tab").fadeIn()
	//}
	//$("#cookie-tab").fadeIn()
	//$(document).on("scroll", function () {
	//	if ($('#back-to-top').hasClass('disabled')) return;
	//	$(window).scrollTop() > 200 ? $('#back-to-top').fadeIn() : $('#back-to-top').fadeOut();

	//	/*$(window).scrollTop() > 10 ? $("#cookie-tab").fadeIn() : $("#cookie-tab").fadeOut();*/
	//});
});
/* End back to top and Cookie buttons */


/*
 *  Sharer JS visual handler
 */
$(function () {
	$(".sharer-trg").each(function () {
		var $currentElement = $(this);
		$currentElement.on("click", function (ev) {
			ev.preventDefault();
			setTimeout(function () {
				$(".social-bar").not($currentElement.find(".social-bar")).removeClass("active");
				$currentElement.find($(".social-bar")).toggleClass("active");
			}, 200);
		});
	});
});


/*
 *  Table responsiveness
 */
$(function () {
	$(".article-body table").each(function () {
		$(this).wrap("<div class='table-responsive'></div>");
	})
})


$(function () {

	$("a.catering-strip-item").on("click", function(ev) {
		ev.preventDefault()
		$(".strip-item-detail").hide();
		$(".strip-item-detail-overlay").fadeIn();
		$(this).parent().next().fadeToggle();
	})

	$(".strip-item-detail-close").on("click", function (ev) {
		ev.preventDefault()
		$(this).closest(".strip-item-detail").fadeOut();
		$(".strip-item-detail-overlay").fadeOut();
	})

})

$(function () {

	//console.log(detectBsBreakpoint())
	$(".swiper-slide-mobile").on("click", function () {
		$(this).toggleClass("swiper-slide-mobile-over");
	})

	$("#incontri-grid > a").on("click", function (ev) {
		if (detectBsBreakpoint().index < 3) {
			$(this).toggleClass("incontri-grid-item-over")
		}
	})
})





/*
	Fancybox sugli elementi con data-multimediaobject valorizzato
*/
//$(function () {
//	$(document).on('click', '[data-multimediaobject]', function (ev) {
//		//$('[data-multimediaobject]').on('click', function (ev) {
//		ev.preventDefault();
//		var $this = $(this);
//		var multimedia = $this.data('multimediaobject');
//		var isThereAnymultimediaContent = $.grep(multimedia, function (el) {
//			return (el['media-type'] == 'audio' || el['media-type'] == 'video');
//		}).length;
//		var buttons = ['fullScreen', 'share', 'close'];
//		if (!isThereAnymultimediaContent) buttons.splice(2, 0, 'thumbs');

//		var fancy = new Fancybox(multimedia,
//			{
//				Thumbs: {
//					type: "classic"
//				},
//				iframe: {
//					preload: false
//				},
//				groupAll: true,
//				afterShow: function (instance, slide) {
//					slide.$content.find('iframe').delay(500).animate({
//						opacity: 1
//					});
//				},
//				thumbs: {
//					autoStart: (!isThereAnymultimediaContent) // && !isMobile()
//				},
//				buttons: buttons,
//				hash: $this.data('hash'),
//				lang: "it",
//				loop: false,
//				i18n: it
//			}
//		);
//	})
//})
